import { createFileRoute } from '@tanstack/react-router';
import TerminalMergeView from '../terminal/ManageTerminalsView/components/TerminalMergeView';
export const Route = createFileRoute('/terminals/locations/$terminalId_/merge')({
  component: TerminalMergeView,
});
